export default "__VITE_ASSET__BQSCCPyX__"